export const STORE_LOGO = 'STORE_LOGO';
export const SEARCH = 'SEARCH';
export const STORE_DATA = 'STORE_DATA';
export const STORE_TIMING = 'STORE_TIMING';
export const GET_COUNTRIES = 'GET_COUNTRIES';
export const GET_CITY = 'GET_CITY';
export const GET_AREA = 'GET_AREA';
export const GET_PICKUP = 'GET_PICKUP';
export const SELECTED_BRANCH = 'SELECTED_BRANCH';
export const GET_PROMOTION = 'GET_PROMOTION';

export const GET_CATEGORIES = 'GET_CATEGORIES';
export const SELECT_CATEGORY = 'SELECT_CATEGORY';
export const GET_CATEGORY_PRODUCTS = 'GET_CATEGORY_PRODUCTS';
export const GET_PRODUCT = 'GET_PRODUCT';
export const UPDATE_DATA_STATE = 'UPDATE_DATA_STATE';
export const GET_SOCIAL_ICON = 'GET_SOCIAL_ICON';
export const GET_ORDER_CHECK_STATUS = 'GET_ORDER_CHECK_STATUS';
export const MAKE_ORDER = 'MAKE_ORDER';
export const CHECK_ORDER = 'CHECK_ORDER';
export const GET_PROMOTION_BANNERS = 'GET_PROMOTION_BANNERS';
export const GET_PINNED_BOX = 'GET_PINNED_BOX';